import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp, Plus } from 'lucide-react';

interface ClientGoalsProps {
  clientId: string;
}

export function ClientGoals({ clientId }: ClientGoalsProps) {
  const goals = [
    {
      id: 1,
      name: 'Weight Loss',
      target: '10kg',
      current: '8.5kg',
      progress: 85,
      deadline: '2024-06-01'
    },
    {
      id: 2,
      name: 'Strength Gain',
      target: '100kg',
      current: '72kg',
      progress: 72,
      deadline: '2024-07-01'
    },
    {
      id: 3,
      name: 'Running Distance',
      target: '10km',
      current: '7km',
      progress: 70,
      deadline: '2024-05-15'
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Target className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold">Goals & Progress</h2>
        </div>
        <button className="theme-button px-3 py-1.5 rounded-lg text-sm flex items-center gap-1">
          <Plus className="w-4 h-4" />
          Add Goal
        </button>
      </div>

      <div className="space-y-6">
        {goals.map((goal, index) => (
          <motion.div
            key={goal.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="space-y-2"
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">{goal.name}</div>
                <div className="text-sm text-muted-foreground">
                  {goal.current} / {goal.target}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <TrendingUp className="w-4 h-4 text-success" />
                <span className="text-success">{goal.progress}%</span>
              </div>
            </div>
            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full bg-primary transition-all"
                style={{ width: `${goal.progress}%` }}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}